import { Component, OnInit, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { CONSTANTS } from '../../../app/shared/constants';
import Typewriter from 'typewriter-effect/dist/core';
import { CommonsService } from 'src/app/services/commons.service';
import { LoadingAkanaService } from 'src/app/services/loading-akana.service';
import { trigger, style, animate, transition } from '@angular/animations';

declare var document: any;
declare var $: any;

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(2500, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class HomeComponent implements OnInit {

  dataAccess: any;
  lengthObject: number;
  lastScrollTop = 0;
  arr = ['scape-nothing', 'stats', 'discover-goals', 'video', 'faq-container'];
  cont = 0;
  typeWritting: any;
  sendEvent = true;
  burger = false;

  constructor(private readonly translation: TranslateService, private route: Router, private c: CommonsService, private l: LoadingAkanaService) { }
  @HostListener('window:scroll', ['$event'])
  readScrollAndEfects($event) {
    const scrollOffset = $event.srcElement.children[0].scrollTop;
    const st = window.pageYOffset || document.documentElement.scrollTop;
    this.scrollDown(scrollOffset);
    this.lastScrollTop = st <= 0 ? 0 : st;
  }

  ngOnInit() {
    sessionStorage.setItem('getParams', null);
    //Script encuesta
    var _kiq = _kiq || [];
    (function () {
      setTimeout(function () {
        var d = document, f = d.getElementsByTagName('script')[0], s = d.createElement('script'); s.type = 'text/javascript';
        s.async = true; s.src = 'https://cl.qualaroo.com/ki.js/77027/iNP.js'; f.parentNode.insertBefore(s, f);
      }, 1);
    })();
    this.c.finishSession();
    this.c.reloadOTBanner();
    this.c.clearDup();
    this.c.firstChargePage('Home', 'Presentacion de producto', 'Home');
    this.c.eventsAnalitics('visit screen', 'content', 'Home');
    this.l.setShowLoading(false);
    this.typeWritting = new Typewriter('#typewriter', {
      strings: CONSTANTS.arrayPhrases,
      autoStart: true,
      loop: true
    });
    $('.container').fadeIn(1000, () => {
      this.translation.get(['FAQS.ANSWERS', 'FAQS.QUESTIONS']).subscribe(data => {
        this.dataAccess = data['FAQS.QUESTIONS'];
        this.lengthObject = Object.keys(this.dataAccess).length;
      });
      if (window.innerWidth > 1024) {
        $('.mobile-background').fadeIn(1500);
      }
    });
  }

  ngAfterViewInit() {
    // Modify the tabindex of the dynamically generated element
    const elements = document.querySelectorAll('.cdk-visually-hidden.cdk-focus-trap-anchor');
  
    // Iterate through the NodeList and set tabindex to -1 for each element
    elements.forEach((element) => {
      element.setAttribute('tabindex', '-1');
    });
  }

  /**
   * renderiza segun van acercandose a los elementos
   * @param scrollOffset: nivel de scroll
   * @param value: valor de renderizado
   */
  scrollDown(scrollOffset) {
    if (scrollOffset === 0) {
      $('#fondo').removeClass('move-right');
      $('#fondo2').removeClass('move-left');
      $('#fondo3').removeClass('move-right');
      $('#fondo4').fadeOut(1000);
    }
    if (scrollOffset >= this.getTopValues(this.arr[0]) && scrollOffset <= this.getTopValues(this.arr[1])) {
      $('#fondo').addClass('move-right');
    }
    if (scrollOffset >= this.getTopValues(this.arr[1]) && scrollOffset < this.getTopValues(this.arr[2])) {
      $('#fondo2').addClass('move-left');
      $('#fondo').removeClass('move-right');

    }
    if (scrollOffset >= this.getTopValues(this.arr[2]) && scrollOffset < this.getTopValues(this.arr[3])) {
      $('#fondo3').addClass('move-right');
      $('#fondo2').removeClass('move-left');
      $('#fondo4').fadeOut(1000);
    }
    if (scrollOffset >= this.getTopValues(this.arr[3]) && scrollOffset < this.getTopValues(this.arr[4])) {
      $('#fondo4').fadeIn(1000);
      $('#fondo3').removeClass('move-right');
      this.recursiveFAQs();
    }
  }

  recursiveFAQs() {
    this.cont = ++this.cont;
    if (this.cont <= this.lengthObject) {
      $('#faq_' + this.cont).fadeIn(1500, () => {
        this.recursiveFAQs();
      });
    }
  }

  /**
   * Altura de los elementos en la estructura
   * @param divClass: selector de clase
   */
  getTopValues(divClass) {
    const height = $(window).height();
    return (document.getElementsByClassName(divClass)[0].offsetTop - height) +
      (document.getElementsByClassName(divClass)[0].clientHeight / 1.5);
  }

  /**
   * Añade una clase en el acordeon para producir un efecto de transición
   * @param id: string
   */
  readAccordion(id, faq) {
    this.c.eventsAnalitics('click', 'FAQs', this.dataAccess[faq]);
    const acc = document.getElementById(id);
    acc.classList.toggle('active');
    const panel = acc.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  }

  /**
   * @param e: elemento no draggable
   */
  disableDragging(e) {
    e.preventDefault();
  }

  /**
   * navegar a url terminos y condiciones
   */
  goToUrl(route: string, button?: string, query?: any) {
    this.c.eventsAnalitics('click', 'Pulsar botón '.concat(button), '/home');
    this.route.navigate([route], { queryParams: query });
  }

  /**
   * desplegar menu
   */
  stickyMenu = () => {
    this.burger = !this.burger;
  }
}
